const classHomeWork = {
  path: 'classHomeWork/:myClassId',
  component: resolve => require(['../../../../components/pages/student_user/classHomeWork'], resolve),
  props: true
}
export default classHomeWork



// WEBPACK FOOTER //
// ./src/router/pages/student_user/classHomeWork/index.js